import type { SxProps, Theme } from '@mui/material';

export const tabPanel: SxProps<Theme> = {
  pt: 3,
};

export const analyticsSectionContainer: SxProps<Theme> = {
  mb: 4,
};

export const analyticsSectionCard: SxProps<Theme> = (theme: Theme) => ({
  backgroundColor: theme.palette.background.paper,
  border: `1px solid ${theme.palette.divider}`,
  borderRadius: 2,
  minHeight: 400,
  overflow: 'hidden',
  boxShadow: 'none',
  '--Paper-overlay':
    'linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, 0))',
  '--Paper-shadow': 'none',
});

export const analyticsSectionTitle: SxProps<Theme> = {
  fontWeight: 500,
  fontSize: '20px',
  lineHeight: 1.5,
  margin: 0,
  px: 3,
  pt: 3,
  pb: 2,
};

export const analyticsSectionContent: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: 320,
  px: 3,
  pb: 3,
};

export const headerContainer: SxProps<Theme> = {
  py: 4,
  px: 3,
};

export const headerTitle: SxProps<Theme> = {
  mb: 0,
  fontWeight: 400,
  fontSize: '34px',
  lineHeight: 1.235,
};

export const mainContainer: SxProps<Theme> = {
  px: 3,
  flexGrow: 1,
  pb: 10,
};

export const tabsContainer: SxProps<Theme> = {
  borderBottom: 1,
  borderColor: 'divider',
  mb: 3,
};

export const tabs: SxProps<Theme> = {
  '& .MuiTab-root': {
    textTransform: 'none',
    fontWeight: 500,
    fontSize: '14px',
    color: 'text.secondary',
    minHeight: 42,
    '&.Mui-selected': {
      color: '#b388ff',
    },
  },
  '& .MuiTabs-indicator': {
    backgroundColor: '#b388ff',
    height: 2,
  },
};

export const emptyStateContainer: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: 400,
};

